import { BACKEND_URL } from "../config";

export function getToken() {
  return localStorage.getItem("aurelia_token");
}

export function setToken(token) {
  if (token) localStorage.setItem("aurelia_token", token);
  else localStorage.removeItem("aurelia_token");
}

export async function api(path, options = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BACKEND_URL}${path}`, { ...options, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Request failed");
  }
  return data;
}

export function mediaUrl(src) {
  if (!src) return "";
  if (/^(https?:|data:|blob:)/i.test(src)) return src;
  const path = src.startsWith("/") ? src : `/${src}`;
  return `${BACKEND_URL}${path}`;
}

export async function uploadImage(file) {
  const headers = {};
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const body = new FormData();
  body.append("image", file);

  const res = await fetch(`${BACKEND_URL}/api/owner/images`, {
    method: "POST",
    headers,
    body,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Upload failed");
  }
  return data.url;
}

export function money(value, currency = "LKR") {
  return new Intl.NumberFormat("en-LK", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(Number(value) || 0);
}

export function typeLabel(type) {
  if (type === "hotel") return "Hotel stay";
  if (type === "wedding-hall") return "Wedding hall";
  return "Stay + celebrate";
}
